const STCCheckListItem = ({ item = "", id = "", children }) => {
  return (
    <>
      <li>
        <div>
          <span className="icon-check-circle"></span>
        </div>
        <div id="ccb-info">
          <div className="copy-md" id={`bndinfo${id}`}>
            {item}
          </div>
          {children}
        </div>
      </li>
    </>
  );
};
export default STCCheckListItem;
